import { useCallback, useSyncExternalStore } from 'react'

import { getTheme, setTheme, subscribeTheme, type Theme } from './theme'

/**
 * The current theme and a toggle, kept live.
 *
 * An external store rather than React state: the footer, the account menu and
 * the mobile sheet each render a toggle, and the theme lives on `<html>`, not
 * in the tree. One store means flipping any of them updates all three — and a
 * change from another tab (see `subscribeTheme`) reaches them too.
 */
export function useTheme(): { theme: Theme; toggleTheme: () => void } {
  const theme = useSyncExternalStore(subscribeTheme, getTheme, () => 'light' as const)
  const toggleTheme = useCallback(() => setTheme(getTheme() === 'dark' ? 'light' : 'dark'), [])
  return { theme, toggleTheme }
}
